const handleFixQuickView = (id) => {
  const { TD_KEY, PL_KEY, CP_KEY, MC_KEY, PRODUCT_FORM_ID } = BSS_B2B.enum;
  const tdUtils = BSS_B2B.td?.utils;
  const plUtils = BSS_B2B.pl?.utils;
  const cpUtils = BSS_B2B.cp?.utils;
  const mcUtils = BSS_B2B.mc?.utils;

  async function handleShowProductFormPrice(product, productFormId) {
      try {
          let arrVariant = [];
          const variantId = product.currentVariant?.id || product.variants[0].id;
          const curVariant = BSS_B2B.storage.variantStorage.get(variantId);
          if (product.location === 'quick_order_list' || product.location === 'quickview') {
              arrVariant = product?.variants || [];
          } else {
              arrVariant = [curVariant];
          }

          for (const variantItem of arrVariant) {
              if (!variantItem) continue;
              const variant = BSS_B2B.storage.variantStorage.get(variantItem.id);
              if (!variant) continue;
              if (variant?.appliedTD) {
                  if (tdUtils) {
                      tdUtils.product.showPrice(productFormId, variantItem.id);
                  }
              } else if (variant?.appliedPL) {
                  if (plUtils) {
                      plUtils.product.showPrice(productFormId, variantItem.id);
                  }
              } else if (variant?.appliedCP) {
                  if (cpUtils) {
                      cpUtils.product.showPrice(productFormId, variantItem.id);
                  }
              } 
          }
      } catch (e) {
          BSS_B2B.logger.error('Product form price flow:', e);
      } finally {
          const productForm = document.querySelector(`[${PRODUCT_FORM_ID}="${productFormId}"]`);
          productForm?.querySelectorAll('[bss-b2b-product-price]').forEach((element) => element.addCss({ visibility: 'visible' }));
      }
  };

  for (const [productFormId, product] of BSS_B2B.storage.productFormStorage.getAll()) {
    const newP = BSS_B2B.storage.productFormStorage.get(productFormId);
    if (newP.location === "quickview") {
      newP.location = "quick_order_list";
      BSS_B2B.storage.productFormStorage.set(productFormId, newP);
    }
    handleShowProductFormPrice(product, productFormId);
  }
}

// document.addEventListener('DOMContentLoaded', function () {
//    document.querySelectorAll("modal-opener").forEach(target => {
//     target.addEventListener("click", (e) => {
//       let text = e.target.parentElement.getAttribute("id");
//       let match = text.match(/QuickBulk-(\d+)-/);
//       if (match && match[1]) {
//         const productId = Number(match[1]);
//         const product = BSS_B2B.storage.productStorage.get(productId);
//         const variantIds = new Map();
//         variantIds.set(productId, product.variants);
//         fixLazyLoad({
//           productIds: [productId],
//           variantIds,
//           notExistProductIds: [productId],
//         })
//         setTimeout(() => {
//           handleFixQuickView(productId);
//         }, 1000);
//       }
//     })
//   })        
// });

document.addEventListener("bss_b2b:QuickviewLoadedCustom", (e) => {
  const productId = +e.detail?.product_id;
  const product = BSS_B2B.storage.productStorage.get(productId);
  const variantIds = new Map();
  variantIds.set(productId, product?.variants);
  fixLazyLoad({
    productIds: [productId],
    variantIds,
    notExistProductIds: [productId],
  })
  handleFixQuickView(productId);
});

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

function actionLazyLoad({ productSubject }) {
  fixLazyLoad = (res) => {
    productSubject.notifyObserver("fixLazyLoad", "LoadedLazyProduct", {
        ...res,
    });
    window.dispatchEvent(new Event("bss_b2b:CustomInitProductSubject"));
  }
}
BSS_B2B.addAction('detect:product/lazy_load', actionLazyLoad);

(function observeAddButtonPrice() {
  const getPriceFromElement = (el) => {
    if (!el) return 0;
    const spanList = el.querySelectorAll('span');
    if (spanList.length < 2) return 0;
    const text = spanList[1].innerText; // cp
    const match = text.match(/[\d,.]+/);
    if (!match) return 0;
    return parseFloat(match[0].replace(',', '.'));
  };

  const observer = new MutationObserver(() => {
    const productPrice1 = document.querySelector('.product-price-1');
    const productPrice2 = document.querySelector('.product-price-2');
    const addBtn = document.querySelector('.form__fieldset button');


    if (productPrice1 && productPrice2 && addBtn) {
      const price1 = getPriceFromElement(productPrice1);
      const price2 = getPriceFromElement(productPrice2);
      const total = (price1 + price2).toFixed(2);
      addBtn.style.setProperty('--price-text', `"(${total} €)"`);

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    observer.disconnect();
  }, 5000);
})();


document.addEventListener("click", e => {
    if(e.target.classList.contains("quantity__button")) {
        setTimeout(() => {
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        }, 1700)
    }
}, true);

document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    setTimeout(() => {
        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, 1000)
})